goog.provide('el8.apphome.docMgr.util');

goog.require('el8.util.feed');


el8.apphome.docMgr.util.isSameInbox = function(inbox1, inbox2) {
    // Need this helper since inbox names can either be string ("manual") or integers
    return (inbox1 === inbox2) || (inbox1*1 === inbox2*1);
};

el8.apphome.docMgr.util.isInView = function($elt, _top, _bottom, _padding) {
    var padding = _padding || 30;
    var itemTop = $elt.offset().top - padding;
    var itemBottom = itemTop + $elt.outerHeight(true);
    if ((itemTop >= _top && itemTop <= _bottom) ||
            (itemBottom >= _top && itemBottom <= _bottom) ||
                (itemBottom >= _bottom && itemTop <= _top)) {
        return true;
    }
    return false;
};

el8.apphome.docMgr.util.loadImage = function($elt, spec) {
    /* Wrapper for el8.util.feed.loadSingleImage */
    spec.showZoomableCursor = false;
    el8.util.feed.loadSingleImage($elt, spec);
};

el8.apphome.docMgr.util.refreshImage = function($img, spec) {

    spec = spec || {};
    var imageWrapSelector = spec.imageWrapSelector || null;
    var successCb = spec.successCb || null;
    var errorCb = spec.errorCb || null;
    var width = spec.width || null;

    if (!$img.length) { return; }
    var $replace = $('<div>').attr('data-id', $img.attr('data-id'))
                        .attr('data-src', $img.attr('src'));
    var imageClass = $img.attr('class');
    $img.replaceWith($replace);
    el8.apphome.docMgr.util.loadImage($replace, {
        imageClass: imageClass,
        forceRefresh: true,
        width: width,
        imageWrapSelector: imageWrapSelector,
        successCb: successCb,
        errorCb: errorCb
    });
};


